import {
  createFrontendPlugin,
  SubPageBlueprint,
} from '@backstage/frontend-plugin-api';
import { TrpcApiBlueprint } from '@ipen-portal/plugin-trpc-react';

import { entityValidationApiRef } from './apis';

export const validationErrorsPlugin = createFrontendPlugin({
  extensions: [
    TrpcApiBlueprint.make({
      name: 'entity-validation-api',
      params: defineParams =>
        defineParams({
          apiRef: entityValidationApiRef,
          path: 'entity-validation',
        }),
    }),
    SubPageBlueprint.make({
      attachTo: { id: 'page:devtools', input: 'pages' },
      params: {
        loader: () =>
          import('./pages/EntityValidation').then(m => <m.EntityValidation />),
        path: 'entity-validation',
        title: 'Entity Validation',
      },
    }),
  ],
  pluginId: 'entity-validation',
});
